import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  connect() {
    this._ts = new TomSelect(this.element, {
      valueField: 'value',
      labelField: 'label',
      searchField: ['label'],
      maxItems: 1,
      create: false,
      delimiter: '\x00',
      shouldLoad: query => query.length >= 1,
      load(query, callback) {
        fetch(`/gatherers/artists_autocomplete?term=${encodeURIComponent(query)}`)
          .then(r => r.json())
          .then(items => callback(items.map(s => ({ value: s, label: s }))))
          .catch(() => callback());
      }
    });
  }

  disconnect() {
    this._ts?.destroy();
  }
}
